interface Props {
  color?: string
  width?: number
  height?: number
}

export const TikTokIcon = ({ color = '#6F6F6F', width = 20, height = 22 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.23216 8.33755C4.89651 8.18191 2.57788 9.33208 1.27626 11.788C-0.676148 15.4719 0.937451 21.5 7.4509 21.5C13.9644 21.5 14.1528 15.413 14.1528 14.7753C14.1528 14.3502 14.1528 11.9732 14.1528 7.64439C15.5459 8.49774 16.7206 9.01143 17.6766 9.18548C18.6327 9.35947 19.2404 9.4366 19.5 9.41682V5.86927C18.6157 5.76617 17.851 5.56961 17.2058 5.2797C16.2381 4.84483 14.3192 3.63786 14.3192 1.86892C14.3205 1.87757 14.3205 1.42127 14.3192 0.5H10.2871C10.2751 9.16444 10.2751 13.9229 10.2871 14.7753C10.3051 16.054 9.27943 17.8427 7.19979 17.8427C5.12015 17.8427 4.09446 16.0554 4.09446 14.9027C4.09446 14.197 4.34512 13.1741 5.38123 12.4166C5.99567 11.9674 6.84848 11.788 8.23216 11.788C8.23216 11.3741 8.23216 10.2239 8.23216 8.33755Z"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  )
}
